var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import { useState, useRef, useEffect } from 'react';
import { useFloating, useClick, useDismiss, useInteractions, useFloatingNodeId, shift, arrow, offset, FloatingArrow, FloatingNode, FloatingPortal, FloatingFocusManager, FloatingTree, useHover, safePolygon, } from '@floating-ui/react';
import clsx from 'clsx';
import style from './HeaderMenuButton.module.scss';
import { HeaderMenuProvider, useHeaderMenuContext } from '../HeaderMenuContext';
export function RenderHeaderMenuButton(_a) {
    var _b, _c;
    var wrapperClassName = _a.wrapperClassName, button = _a.button, header = _a.header, headerUrl = _a.headerUrl, children = _a.children, footer = _a.footer, _d = _a.width, width = _d === void 0 ? 332 : _d, _e = _a.interactionType, interactionType = _e === void 0 ? 'hover' : _e, _f = _a.type, type = _f === void 0 ? 'default' : _f;
    var _g = useState(false), isOpen = _g[0], setIsOpen = _g[1];
    var arrowRef = useRef(null);
    var nodeId = useFloatingNodeId();
    var updateParentPositionY = useHeaderMenuContext().updateParentPositionY;
    var _h = useFloating({
        nodeId: nodeId,
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            offset(12),
            shift(),
            arrow({
                element: arrowRef,
            }),
        ],
    }), x = _h.x, y = _h.y, strategy = _h.strategy, refs = _h.refs, context = _h.context;
    useEffect(function () {
        if (y && y !== 0) {
            updateParentPositionY(y);
        }
    }, [updateParentPositionY, y]);
    var click = useClick(context, { enabled: interactionType === 'click' });
    var hover = useHover(context, {
        restMs: 50,
        handleClose: safePolygon(),
        enabled: interactionType === 'hover',
    });
    var dismiss = useDismiss(context);
    var _j = useInteractions([click, hover, dismiss]), getReferenceProps = _j.getReferenceProps, getFloatingProps = _j.getFloatingProps;
    return (_jsx(FloatingTree, { children: _jsxs("div", __assign({ className: wrapperClassName }, { children: [_jsx("button", __assign({ type: "button", ref: refs.setReference }, getReferenceProps(), { className: style.button }, { children: button && button(isOpen) })), _jsx(FloatingNode, __assign({ id: nodeId }, { children: _jsx(FloatingPortal, { children: isOpen && (_jsx(FloatingFocusManager, __assign({ context: context, initialFocus: -1 }, { children: _jsxs("div", __assign({ className: clsx(style.dropdown, (_b = {},
                                    _b[style.borderedDropdown] = type === 'accountDropdown',
                                    _b)), ref: refs.setFloating }, getFloatingProps(), { style: {
                                    position: strategy,
                                    top: y !== null && y !== void 0 ? y : 0,
                                    left: x !== null && x !== void 0 ? x : 0,
                                    width: width,
                                    zIndex: 1021, // 1020 = header
                                } }, { children: [header && (_jsx("div", __assign({ "aria-hidden": true, className: clsx(style.headerWrapper, (_c = {}, _c[style.hoverable] = headerUrl, _c)), onClick: headerUrl
                                            ? function () {
                                                window.location.href = headerUrl;
                                            }
                                            : undefined }, { children: header }))), children, footer && _jsx("div", __assign({ className: clsx(style.footerWrapper) }, { children: footer })), _jsx(FloatingArrow, { ref: arrowRef, context: context, height: 12, width: 16, fill: "#ffffff", stroke: "#d9d9d9", strokeWidth: 1, className: style.floatingArrow })] })) }))) }) }))] })) }));
}
export function HeaderMenuButton(props) {
    return (_jsx(HeaderMenuProvider, { children: _jsx(RenderHeaderMenuButton, __assign({}, props)) }));
}
